import Vue from 'vue'

/**
 *获取集成账号列表
 * @param {*} params
 */
export const findUsers = (params) => {
  return Vue.fetch.post('/apiv1/hr/intergration/findUsers', params)
}

/**
 *新增集成账号
 * @param {*} params
 */
export const createUsers = (params) => {
  return Vue.fetch.post('/apiv1/hr/intergration/create', params)
}

/**
 *删除集成账号
 * @param {*} params
 */
export const deleteUsers = (params) => {
  return Vue.fetch.post('/apiv1/hr/intergration/delete', params)
}

/**
 *更新集成账号
 * @param {*} params
 */
export const updateUsers = (params) => {
  return Vue.fetch.post('/apiv1/hr/intergration/update', params)
}



// WEBPACK FOOTER //
// ./src/services/integratedAccountApi.js